
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBuildingColumns, faCreditCard, faMoon } from '@fortawesome/free-solid-svg-icons'

import MenuIcon from '@mui/icons-material/Menu'
import _AppBar from '@mui/material/AppBar'

import { MatomoProvider, createInstance as createMatomoInstance } from '@jonkoops/matomo-tracker-react'

import React, { Fragment as F,
  useContext, useEffect, useLayoutEffect, useRef, useState,
} from 'react'
import { useKeycloak } from '@react-keycloak/web'
import Modal from 'react-modal'
import {
  Link,
  BrowserRouter as Router,
  Route,
  Routes,
  useParams,
} from "react-router-dom"
import Select from 'react-select'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import config from 'config'

import { AppCtx } from 'src/App'

import {
  useApiRouter,
  appRouter,
  C,
  logg,
} from '$shared'

import {
  /* singular */
  BankSchedules,
  // BankShow,
  /* plural */
  BanksCtx,
  BanksIndex,
  BanksSearchModal,
  ResultsTable,
} from '$src/components/banks'
import {
  DocsSearch,
  SchedulesCtx,
  SchedulesShowModal,
} from '$src/components/schedules'

library.add( faBuildingColumns, faCreditCard, faMoon )

/*
 * Breadcrumbs
**/
const Breadcrumbs = () => {
  // logg(null, 'Breadcrumbs')

  /* ctx */

  const {
    actionName, setActionName,
    breadcrumbsActions, setBreadcrumbsActions,
    cuEmail,
    drawerOpen,   setDrawerOpen,
    loading,      setLoading,
  } = useContext(AppCtx)
  logg(useContext(AppCtx), 'AppCtx in Breadcrumbs')

  const {
    bank,         setBank,
    results, setResults, clearResults,
    resultsTitle,
  } = useContext(BanksCtx)
  logg(useContext(BanksCtx), 'BanksCtx in Breadcrumbs')

  const {
    oneResultTitle, setOneResultTitle, defaultOneResultTitle,
  } = useContext(SchedulesCtx)
  // logg(useContext(SchedulesCtx), 'SchedulesCtx in Breadcrumbs')

  return (<F>
    <div className="Breadcrumbs">
      <div className='left'>
        <div className='mr-3'>
          <MenuIcon onClick={() => setDrawerOpen(drawerOpen === C.classes.sidebarIsOpen ? C.classes.sidebarIsClosed : C.classes.sidebarIsOpen) } />
        </div>
        { resultsTitle }
        { oneResultTitle && <F>
            { resultsTitle && <F>&nbsp;&nbsp;|&nbsp;&nbsp;</F> }
            <b className='OneResultTitle'>{ oneResultTitle }</b>
        </F> || <Link to="/">
          <div className='clear-results-btn' onClick={() => {
            clearResults()
            setActionName(null)
          } }>&nbsp;&times;&nbsp;</div>
        </Link> }
        { [ C.actions['banks#results'], C.lists_actions.modify, C.queries_actions.create ].indexOf(actionName)!==-1 &&
          results.length &&
            breadcrumbsActions || null }
      </div>
      <div className='right'>
        { 'docs#show' === actionName && <DocsSearch /> }
      </div>
    </div>
  </F>)
}
export default Breadcrumbs
